__turbopack_context__.v({
  "className": "caudex_483631e9-module__DFgdIa__className",
  "variable": "caudex_483631e9-module__DFgdIa__variable",
});
